import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Store, CalendarCheck, ShieldAlert, Umbrella, LifeBuoy, Star, Wallet, Settings, ScrollText, LogOut, Menu, X, Users, Inbox, UserCog, FileText, Newspaper, ShieldCheck, Scale, Rocket } from "lucide-react";
import { useAuth, hasPerm } from "@/context/AuthContext";
import { Logo, LangToggle } from "@/components/CustomerShell";

export const ADMIN_NAV = [
  ["", "Dashboard", LayoutDashboard, null],
  ["providers", "Anbieter", Store, "providers"],
  ["bookings", "Buchungen", CalendarCheck, "bookings"],
  ["users", "Nutzer", Users, "users"],
  ["inbox", "Postfach", Inbox, "messages"],
  ["complaints", "Reklamationen", ShieldAlert, "complaints"],
  ["insurance", "Reklamationen (Schäden)", Umbrella, "insurance"],
  ["insurance-reviews", "Versicherungsprüfungen", ShieldCheck, "insurance"],
  ["tickets", "Support", LifeBuoy, "tickets"],
  ["reviews", "Bewertungen", Star, "reviews"],
  ["finance", "Finanzen", Wallet, "finance"],
  ["config", "Konfiguration", Settings, "config"],
  ["website-status", "Website-Status", Rocket, "config"],
  ["content", "Inhalte", FileText, "config"],
  ["blog", "Blog", Newspaper, "config"],
  ["legal", "Rechtstexte", ScrollText, "config"],
  ["compliance", "Rechtliches & Verbraucherschutz", Scale, "compliance"],
  ["staff", "Mitarbeiter", UserCog, "staff"],
  ["audit", "Audit-Log", ScrollText, "audit"],
];

function SideNav({ onNav }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="flex flex-col h-full">
      <div className="p-5 border-b border-line"><Logo /><p className="w-muted mt-2 text-sm">Backoffice · {user.name} ({user.role})</p></div>
      <nav className="flex-1 overflow-y-auto p-3 space-y-1" aria-label="Backoffice">
        {ADMIN_NAV.filter((n) => n[3] === null || hasPerm(user, n[3])).map(([to, label, Icon]) => (
          <NavLink key={to} to={`/admin${to ? `/${to}` : ""}`} end onClick={onNav} data-testid={`admin-nav-${to || "dashboard"}`}
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl font-semibold ${isActive ? "bg-mint-soft text-mint-ink" : "hover:bg-gray-100"}`}>
            <Icon size={20} aria-hidden="true" /> {label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-line flex gap-2">
        <LangToggle />
        <button className="w-btn w-btn-secondary flex-1" onClick={async () => { await logout(); nav("/backoffice"); }} data-testid="admin-logout-btn"><LogOut size={18} aria-hidden="true" /> Abmelden</button>
      </div>
    </div>
  );
}

export default function AdminShell() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen md:pl-64">
      <aside className="hidden md:block fixed inset-y-0 left-0 w-64 bg-white border-r border-line z-40"><SideNav /></aside>
      <header className="md:hidden sticky top-0 z-40 bg-white border-b border-line h-16 flex items-center justify-between px-4">
        <Logo />
        <button className="w-btn w-btn-secondary !px-3" onClick={() => setOpen(true)} aria-label="Menü öffnen" data-testid="admin-menu-btn"><Menu aria-hidden="true" /></button>
      </header>
      {open && (
        <div className="md:hidden fixed inset-0 z-50 bg-black/40" onClick={() => setOpen(false)}>
          <aside className="w-72 h-full bg-white relative" onClick={(e) => e.stopPropagation()}>
            <button className="absolute right-3 top-3 p-2" onClick={() => setOpen(false)} aria-label="Menü schließen"><X aria-hidden="true" /></button>
            <SideNav onNav={() => setOpen(false)} />
          </aside>
        </div>
      )}
      <main className="p-4 md:p-8 max-w-7xl"><Outlet /></main>
    </div>
  );
}
